import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import {
  Time32,
  UpdateWhite32,
  Excel32,
  JPG32,
  PNG32,
  AddFile32,
  VendorName32,
  Bank32,
  barely_black_bg_img,
  Cancel32,
  Email32,
  Location32,
  PhoneNumber32,
  submit,
} from "../../../../public/LoginImages/importimages";

const WorkOrderList = () => {
  const context = useContext(AdminContext);
  const { GetAllWorkOrderList } = context;
  const [workorder, setWorkOrderList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const getWorkOrderList = async () => {
    let data = await GetAllWorkOrderList();
    console.log("data", data);

    setWorkOrderList(data);
    setFilteredBills(data);
  };
  useEffect(() => {
    getWorkOrderList();
  }, []);
  let workorderList = [];
  if (workorder.length > 0) {
    workorderList = workorder;
  }
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = workorder.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1); // Reset to page 1 on search
  }, [searchTerm, workorder]);


  // new pagination add 28-08-2026
  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;
 
    if (totalPages <= maxVisiblePages) {
        return Array.from(
            { length: totalPages },
            (_, index) => index + 1
        );
    }
 
    // Starting pages
    if (currentPage <= 3) {
        return [1, 2, 3, 4, 5, "...", totalPages];
    }
 
    // Last pages
    if (currentPage >= totalPages - 2) {
        return [
            "...",
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages
        ];
    }
 
    // Middle pages
    return [
        "...",
        currentPage - 2,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        currentPage + 2,
        "...",
        totalPages
    ];
};
const thStyle = {
  padding: "8px",
  position: "sticky",
  top: 0,
  zIndex: 3,
  backgroundColor: "#2D79D9",
};
  return (
     //2/11
     
     <div
   style={{
     width: "100%",
     maxWidth: "1000px",
     margin: "14px auto 0",
     background: "#EEF2F7",
     border: "1px solid #dfe5ee",
     borderRadius: "10px",
     padding: "20px 20px 20px",
     //3/11
         boxSizing: "border-box",
     marginTop: "15px",
     marginBottom: "30px",
   }}
 >
   
        <div
           style={{
             display: "flex",
             justifyContent: "space-between",
             alignItems: "center",
             marginBottom: 10,
             padding: "0 20px",
             width: "100%",
           }}
         >
           <h5
             style={{
               fontWeight: "bold",
               color: "black",
               display: "flex",
               alignItems: "center",
             }}
           >
             <img
               src={"/Work-Order-Report-List-32.png"}
               alt="icon"
               style={{ marginRight: 10, width: 28, height: 28 }}
             />{" "}
             Work Order Report
           </h5>
           <div
             style={{
               display: "flex",
               alignItems: "center",
               backgroundColor: "white",
               border: "1px solid #ccc",
               borderRadius: 5,
               padding: "5px 10px",
               width: 300,
             }}
           >
             <img
               src={"/Search-32.png"}
               alt="search"
               style={{ width: 20, height: 20, marginRight: 8 }}
             />
             <input
               value={searchTerm}
               onChange={(e) => setSearchTerm(e.target.value)}
               placeholder="Search Work Orders..."
               style={{
                 border: "none",
                 outline: "none",
                 background: "transparent",
                 width: "100%",
                 fontSize: 14,
               }}
             />
           </div>
         </div>
         {/* //3/11 */}
            <div
         style={{
           width: "100%",
           boxSizing: "border-box",
           minWidth: 0,
           boxShadow: "0 0 10px rgba(0,0,0,0.1)",
           borderRadius: 20,
           backgroundColor: "white",
           padding: 20,
         }}
       >
        
 {/* //3/11 */}
                 <div style={{ width: "100%", minWidth: 0 }}>
          {/* //3/11 */}
                  <div
   style={{
     height: "350px",
     // minHeight:"350px",
     // maxHeight:"350px",
     overflowY: "auto",
     overflowX: "auto",
     width: "100%",
     maxWidth: "100%",
     border: "1px solid #d9e1f2",
     borderRadius: "8px",
     boxSizing: "border-box",
   }}
 >
   {/* //28/10 */}
             <table
               style={{
       backgroundColor: "white",
       width: "100%",
       minWidth: "70vw",
       borderCollapse: "separate",  
       borderSpacing: 0,            
   
     }}
             >
               <thead>
                 <tr
                 //28/10
                   style={{
                     backgroundColor: "#2D79D9",
                     color: "white",
                     fontSize: 14,
                     fontWeight: 600,
                     textAlign: "left",
                     whiteSpace: "nowrap",
                   }}
                 >
                   <th style={thStyle}>Sr.No</th>
                   <th style={thStyle}>Financial Year</th>
                   <th style={thStyle}>Project ID</th>
                   <th style={thStyle}>Project Name</th>
                   <th style={thStyle}>Project Cost</th>
                   <th style={thStyle}>GR Copy</th>
                   <th style={thStyle}>Budget Head</th>
                   <th style={thStyle}>Vendor Name</th>
                   <th style={thStyle}>Work Name</th>
                   <th style={thStyle}>Work Order No</th>
                   <th style={thStyle}>Work Order Date</th>
                   <th style={thStyle}>Work End Date</th>
                   <th style={thStyle}>Approved Work Amount</th>
                   <th style={thStyle}>Paid Amount</th>
                   <th style={thStyle}>Remaining Amount</th>
                   <th style={thStyle}>Copy of Work Order</th>
                   <th style={thStyle}>Creation Date</th>
                 </tr>
               </thead>
                <tbody>
                     {currentBills && currentBills.length > 0 ? (
     currentBills.map((workorder, index) => {
       return (
                     <tr
                       key={index}
                       style={{
                         //28/10
                         backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                         fontSize: 13,
                         fontWeight: 500,
                         textAlign: "left",
                         whiteSpace: "break-spaces",
                       }}
                     >
                       <td style={{ padding: "10px", border:"1px solid white" }}>
                         {indexOfFirstBill + index + 1}
                       </td>
                       <td style={{ padding: "8px", border:"1px solid white" }}>
                         {workorder.FinancialYear}
                       </td>
                       <td style={{ padding: "8px", color:"#5295c9", fontWeight:"700", border:"1px solid white" }}>{workorder.ProjectID}</td>
                       <td style={{ padding: "8px" ,width:"200px", border:"1px solid white"}}>
                         {workorder.ProjectName}
                       </td>
                      <td style={{ padding: "8px", border:"1px solid white" }}>
   {Number(workorder.ProjectCost || 0).toLocaleString("en-IN")}
 </td>
                       <td style={{ padding: "8px", whiteSpace: "normal", border:"1px solid white" }}>
                         {workorder.GRCopy ? (
                           (() => {
                             const ext = workorder.GRCopy.split(".")
                               .pop()
                               .toLowerCase();
  
                             // Choose icon based on file extension
                             let icon;
                             if (ext === "xls" || ext === "xlsx") {
                               icon = Excel32; // 🟢 Replace with your actual XLS icon import
                             } else if (ext === "jpg" || ext === "jpeg") {
                               icon = JPG32; // 🟢 Replace with your actual JPG icon import
                             } else if (ext === "png") {
                               icon = PNG32; // 🟢 Replace with your actual PNG icon import
                             } else {
                               icon = UpdateWhite32; // default icon (optional)
                             }
                             return (
                               <a
                                 href={`${apiurl}/ProjectDocsImages/${workorder.GRCopy}`}
                                 target="_blank"
                               >
                                 <img
                                   src={icon}
                                   alt={ext + " icon"}
                                   style={{ width: "20px", height: "20px" }}
                                 />
                                 <span>GR Copy </span>
                               </a>
                             );
                           })()
                         ) : (
                           <span style={{ color: "#d9534f", fontWeight: 700 }}>
                             No File
                           </span>
                         )}
                       </td>
                       <td style={{ padding: "8px", border:"1px solid white" }}>{workorder.HeadName || "-"}</td>
                       <td style={{ padding: "8px", border:"1px solid white" }}>
                         {workorder.ContractorName}
                       </td>
                       <td style={{ padding: "8px", border:"1px solid white" }}>{workorder.WorkName}</td>
                       <td style={{ padding: "8px", border:"1px solid white" }}>
                         {workorder.WorkOrderNo}
                       </td>
                       <td style={{ padding: "8px",border:"1px solid white" }}>
                         <img
                           src={"/Time-32.png"}
                           style={{
                             marginRight: "5px",
                             width: "15px",
                             height: "15px",
                           }}
                         />
                         {workorder.WorkOrderDate?.split("T")[0].replace(" ")}
                       </td>
                       <td style={{ padding: "8px", border:"1px solid white" }}>
                         <img
                           src={"/Time-32.png"}
                           style={{
                             marginRight: "5px",
                             width: "15px",
                             height: "15px",
                           }}
                         />
                         {workorder.WorkEndDate?.split("T")[0].replace(" ")}
                       </td>
                     <td style={{ padding: "8px", border:"1px solid white" }}>
   {Number(workorder.ApprovedWorkAmount || 0).toLocaleString("en-IN")}
 </td>
                       <td style={{ padding: "8px",border:"1px solid white" }}>
                         {" "}
                         {Number(workorder.PaidAmount || 0).toLocaleString(
                           "en-IN",
                         )}
                       </td>
                      <td style={{ padding: "8px", border:"1px solid white" }}>
   {Number(workorder.RemainingAmount || 0).toLocaleString("en-IN")}
 </td>
                       <td style={{ padding: 10, border:"1px solid white" }}>
                         {workorder.CopyofWorkOrder ? (
                           (() => {
                             const ext = workorder.CopyofWorkOrder.split(".")
                               .pop()
                               .toLowerCase();
  
                             // Choose icon based on file extension
                             let icon;
                             if (ext === "xls" || ext === "xlsx") {
                               icon = Excel32; // 🟢 Replace with your actual XLS icon import
                             } else if (ext === "jpg" || ext === "jpeg") {
                               icon = JPG32; // 🟢 Replace with your actual JPG icon import
                             } else if (ext === "png") {
                               icon = PNG32; // 🟢 Replace with your actual PNG icon import
                             } else {
                               icon = UpdateWhite32; // default icon (optional)
                             }
                             return (
                               <a
                                 href={`${apiurl}/WorkOrderDocsImages/${workorder.CopyofWorkOrder}`}
                                 target="_blank"
                                 rel="noreferrer"
                               >
                                 <img
                                   src={icon}
                                   alt={ext + " icon"}
                                   style={{ width: "20px", height: "20px" }}
                                 />
                                 <span>Work Order Copy </span>
                               </a>
                             );
                           })()
                         ) : (
                           <span style={{ color: "#d9534f", fontWeight: 700 }}>
                             No File
                           </span>
                         )}
                       </td>
                       {/* <td style={{ padding: '8px' }}>{workorder.PaidAmount}</td> */}
                       <td style={{ padding: 10, whiteSpace: "nowrap",border:"1px solid white" }}>
                         <img
                           src={"/Time-32.png"}
                           style={{
                             marginRight: "5px",
                             width: "15px",
                             height: "15px",
                           }}
                         />
                         {workorder.Date?.split("T")[0]}
                       </td>
                     </tr>
   );
     })
   ) : (
     <tr>
       {/* <td
         colSpan="17"
         style={{
           textAlign: "center",
           padding: "30px",
           color: "#777",
           fontSize: "15px",
           fontWeight: "600",
         }}
       >
         No Data Available
       </td> */}
     </tr>
   )}
 </tbody>
                
  
             </table>
             {/* 29-09 */}
                    {(!Array.isArray(currentBills) || currentBills.length === 0) && (
                         <div
                             style={{
                                 position: "sticky",
                                 left: 0,
                                 width: "100%",
                                 display: "flex",
                                 justifyContent: "center",
                                 alignItems: "center",
                                 height: "150px",
                                 boxSizing: "border-box",
                                 backgroundColor: "#ffffff",
                                 color: "#333",
                                 fontSize: "14px",
                                 fontWeight: 500,
                             }}
                         >
                             No data available
                         </div>
                     )}
           </div>
         </div>
 
         {/* <div
           style={{
             display: "flex",
             justifyContent: "space-between",
             alignItems: "center",
             marginTop: 20,
           }}
         >
           <div>
             <p style={{ fontSize: 16, color: "black" }}>
               Showing{" "}
               {filteredBills?.length
                 ? Math.min(indexOfFirstBill + 1, filteredBills?.length)
                 : 0}{" "}
               to {Math.min(indexOfLastBill, filteredBills?.length)} of{" "}
               {filteredBills?.length} entries
             </p>
           </div>
           <div style={{ display: "flex" }}>
             <button
               onClick={() => setCurrentPage(1)}
               disabled={currentPage === 1}
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
                 color: "#044c92",
                 border: "1px solid #cccccc",
                 cursor: "pointer",
                 transition: "0.2s ease-in-out",
               }}
             >
               &laquo;
             </button>
             <button
               onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
               disabled={currentPage === 1}
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
                 color: "#044c92",
                 border: "1px solid #cccccc",
                 cursor: "pointer",
                 transition: "0.2s ease-in-out",
               }}
             >
               &lt;
             </button>
             <button
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 background:
                   "linear-gradient(to bottom, #044c92 , #0071bc , #022f5a )",
                 color: "white",
                 border: "1px solid #cccccc",
               }}
             >
               {currentPage}
             </button>
             <button
               onClick={() =>
                 setCurrentPage((prev) => Math.min(totalPages || 1, prev + 1))
               }
               disabled={currentPage === totalPages}
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 backgroundColor:
                   currentPage === totalPages ? "#ffffff" : "#e5f4fb",
                 color: "#044c92",
                 border: "1px solid #cccccc",
                 cursor: "pointer",
                 transition: "0.2s ease-in-out",
               }}
             >
               &gt;
             </button>
             <button
               onClick={() => setCurrentPage(totalPages)}
               disabled={currentPage === totalPages}
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 backgroundColor:
                   currentPage === totalPages ? "#ffffff" : "#e5f4fb",
                 color: "#044c92",
                 border: "1px solid #cccccc",
                 cursor: "pointer",
                 transition: "0.2s ease-in-out",
               }}
             >
               &raquo;
             </button>
           </div>
         </div> */}
         {/* previous pagination change --28/08/2026 */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20 }}>
                     <div>
                         <p style={{ fontSize: 14, color: "black" }}>
                             Showing {filteredBills?.length ? Math.min(indexOfFirstBill + 1, filteredBills?.length) : 0} to {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries
                         </p>
                     </div>
                   <div
     style={{
         display: "flex",
         alignItems: "center",
         gap: "18px",
     }}
 >
     {/* Previous */}
     <button
         onClick={() =>
             setCurrentPage((prev) => Math.max(prev - 1, 1))
         }
         disabled={currentPage === 1}
         style={{
             border: "none",
             background: "transparent",
             color: currentPage === 1 ? "#999" : "#2ea4e7",
             cursor:
                 currentPage === 1 ? "not-allowed" : "pointer",
             fontSize: "13px",
             padding: 0,
             display: "flex",
             alignItems: "center",
             gap: "4px",
             opacity: currentPage === 1 ? 0.5 : 1,
         }}
     >
         <span style={{ fontSize: "20px" }}>‹</span>
         Previous
     </button>
  
     {/* Page Numbers */}
     <div
         style={{
             display: "flex",
             alignItems: "center",
             gap: "20px",
         }}
     >
         {getPageNumbers(currentPage, totalPages).map(
             (pageNumber, index) => {
  
                 // ...
                 if (pageNumber === "...") {
                     return (
                         <span
                             key={`ellipsis-${index}`}
                             style={{
                                 fontSize: "13px",
                                 color: "#444",
                             }}
                         >
                             ...
                         </span>
                     );
                 }
  
                 return (
                     <button
                         key={pageNumber}
                         onClick={() => setCurrentPage(pageNumber)}
                         style={{
                             border: "none",
                             background: "transparent",
                             padding: 0,
                             color:
                                 currentPage === pageNumber
                                     ? "#2ea4e7"
                                     : "#444",
                             cursor: "pointer",
                             fontSize: "13px",
                             fontWeight:
                                 currentPage === pageNumber
                                     ? "600"
                                     : "400",
                             textDecoration:
                                 currentPage === pageNumber
                                     ? "underline"
                                     : "none",
                         }}
                     >
                         {pageNumber}
                     </button>
                 );
             }
         )}
     </div>
  
     {/* Next */}
     <button
         onClick={() =>
             setCurrentPage((prev) =>
                 Math.min(prev + 1, totalPages || 1)
             )
         }
         disabled={
             currentPage === totalPages ||
             totalPages === 0
         }
         style={{
             border: "none",
             background: "transparent",
             color:
                 currentPage === totalPages ||
                 totalPages === 0
                     ? "#999"
                     : "#2ea4e7",
             cursor:
                 currentPage === totalPages ||
                 totalPages === 0
                     ? "not-allowed"
                     : "pointer",
             fontSize: "13px",
             padding: 0,
             display: "flex",
             alignItems: "center",
             gap: "4px",
             opacity:
                 currentPage === totalPages ||
                 totalPages === 0
                     ? 0.5
                     : 1,
         }}
     >
         Next
         <span style={{ fontSize: "20px" }}>›</span>
     </button>
 </div>
                 </div>
  
       </div>
     </div>
   );
};

export default WorkOrderList;
